var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.75,
    height: 31.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#185edf"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25549",
    d: "M12.375 18A5.625 5.625 0 1 1 18 12.375 5.625 5.625 0 0 1 12.375 18Zm0-9a3.375 3.375 0 1 0 3.375 3.375A3.375 3.375 0 0 0 12.375 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25550",
    d: "M12.375 31.5 2.884 20.307q-.2-.252-.391-.507A12.25 12.25 0 0 1 0 12.375a12.375 12.375 0 1 1 24.75 0 12.245 12.245 0 0 1-2.492 7.422s-.337.443-.388.5ZM4.288 18.444s.263.346.323.421l7.764 9.157 7.774-9.172c.049-.062.313-.411.314-.412a10.014 10.014 0 0 0 2.037-6.066 10.125 10.125 0 1 0-20.25 0 10.018 10.018 0 0 0 2.04 6.069Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2e1ca24c2b13ebd079eda2e020485818.svg";
export { ForwardRef as ReactComponent };